/* NT promo banner v3 – crossfade slideshow: interval from data-interval (default 2s), loop, pause on hover/focus/touch, pause when tab hidden */
(function () {
  function setup(box) {
    if (box.__ntp) return; box.__ntp = 1;
    var slides = box.querySelectorAll('.nt-promo__slide');
    var dots = box.querySelectorAll('.nt-promo__dots i');
    if (slides.length < 2) return;
    var ms = parseInt(box.getAttribute('data-interval'), 10) || 2000;
    var i = 0, timer = null, paused = false;
    function show(n) {
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true'); slides[i].setAttribute('tabindex', '-1');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); slides[i].removeAttribute('aria-hidden'); slides[i].removeAttribute('tabindex');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    function tick() { if (!paused && !document.hidden) show(i + 1); }
    function start() { clearInterval(timer); timer = setInterval(tick, ms); }
    var area = box.querySelector('.nt-promo__slides') || box;
    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { paused = false; start(); });
    area.addEventListener('focusin', function () { paused = true; });
    area.addEventListener('focusout', function () { paused = false; start(); });
    var tt;
    area.addEventListener('touchstart', function () { paused = true; clearTimeout(tt); }, { passive: true });
    area.addEventListener('touchend', function () { tt = setTimeout(function () { paused = false; start(); }, 2500); }, { passive: true });
    start();
  }
  function init() { document.querySelectorAll('[data-nt-promo]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
